export const consts = {
  MAX_NUMBER_OF_MODIFIER_GROUPS: 20,
  MAX_NUMBER_OF_MODIFIERS_ON_MODIFIER_GROUP: 25,
  MAX_NUMBER_OF_MODIFIERS_ON_MODIFIER_GROUP_ENLARGED: 30,
  MAX_NUMBER_OF_MODIFIERS_ON_MODIFIER_GROUP_ENLARGED_PHASE_2: 50,
  MAX_NUMBER_OF_SELECTED_MODIFIERS: 10,
  // TODO - can be removed after merge experiment
  MAX_NUMBER_OF_SELECTED_MODIFIERS_ENLARGED_NUMBER: 12
};
//# sourceMappingURL=modifiers.js.map